module.exports = __webpack_public_path__ + "media/newstyle/images/publish-book_en-994351687106deb0eb2b975ef6e503d8.png";